import React from "react";
import { Form, Modal } from "react-bootstrap";
import "./Add_note_modal.css";
import Blue_btn from "../../common_btn/blue_btn/Blue_btn";

function Add_note_modal({ message_text, ...props }) {
  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Add_note_modal custom_modal"
      >
        <Modal.Body>
          <h1>Add Note</h1>
          <div className="form_holder">
            <Form>
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlTextarea1"
              >
                <Form.Control
                  placeholder="Add your note here"
                  as="textarea"
                  rows={5}
                />
              </Form.Group>
              <div className="text-center">
                <Blue_btn btn_text={"Submit"} />
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Add_note_modal;
